(function() {
  'use strict';

  // Initialize vote functionality when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    const voteSection = document.querySelector('.iw-vote');
    if (!voteSection) return;

    // Get step elements
    const step1 = voteSection.querySelector('.iw-vote__step--1');
    const step2 = voteSection.querySelector('.iw-vote__step--2');
    const submitButton = voteSection.querySelector('[data-submit-vote]');
    const voteRadios = voteSection.querySelectorAll('input[name="vote_type"]');
    
    // Get popup elements
    const dogPopup = document.querySelector('[data-dog-popup]');
    const catPopup = document.querySelector('[data-cat-popup]');
    const dogPopupTrigger = voteSection.querySelector('[data-dog-popup-trigger]');
    const catPopupTrigger = voteSection.querySelector('[data-cat-popup-trigger]');
    const dogPopupClose = document.querySelector('[data-dog-popup-close]');
    const catPopupClose = document.querySelector('[data-cat-popup-close]');
    
    // Get step 2 elements
    const dogHeader = voteSection.querySelector('#dog-header');
    const catHeader = voteSection.querySelector('#cat-header');
    const dogItem = voteSection.querySelector('#dog-item');
    const catItem = voteSection.querySelector('#cat-item');
    const dogCta = voteSection.querySelector('#dog-cta');
    const catCta = voteSection.querySelector('#cat-cta');
    
    // Get vote counter elements
    const dogCounter = document.getElementById('dog-vote-counter');
    const catCounter = document.getElementById('cat-vote-counter');
    
    // Get block settings (if available via data attributes)
    const step2Block = voteSection.querySelector('[data-step2-settings]');
    const enableRealVote = step2Block?.dataset.enableRealVote === 'true';
    const googleSheetUrl = step2Block?.dataset.googleSheetUrl || '';
    const staticDogScore = parseInt(step2Block?.dataset.dogVoteScore) || 0;
    const staticCatScore = parseInt(step2Block?.dataset.catVoteScore) || 0;
    
    // Debug logging
    console.log('Vote System Initialized:', {
      enableRealVote: enableRealVote,
      googleSheetUrl: googleSheetUrl ? 'Set' : 'Not set',
      staticDogScore: staticDogScore,
      staticCatScore: staticCatScore
    });

    // Check if user has already voted
    function hasUserVoted() {
      return localStorage.getItem('iw-vote-submitted') === 'true';
    }

    // Mark user as voted
    function markUserAsVoted() {
      localStorage.setItem('iw-vote-submitted', 'true');
      localStorage.setItem('iw-vote-type', voteSection.querySelector('input[name="vote_type"]:checked')?.value || '');
    }

    // Handle vote submission
    if (submitButton) {
      submitButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Check if user has already voted
        if (hasUserVoted()) {
          const previousVote = localStorage.getItem('iw-vote-type');
          alert('You have already voted! (' + (previousVote === 'dog' ? 'Dog' : 'Cat') + ')');
          
          // Show step 2 with previous vote
          if (step1) step1.classList.remove('active');
          if (step2) {
            step2.classList.add('active');
            showStep2ForVote(previousVote);
            
            // Reset counters to 0 before animating
            if (dogCounter) dogCounter.textContent = '0';
            if (catCounter) catCounter.textContent = '0';
            
            // Animate counters after a short delay
            setTimeout(function() {
              updateVoteCountersStatic(true);
            }, 100);
            
            step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          return;
        }
        
        const selectedVote = voteSection.querySelector('input[name="vote_type"]:checked');
        
        if (!selectedVote) {
          alert('Please select an option before submitting your vote.');
          return;
        }

        const voteType = selectedVote.value;
        
        // Disable button during submission
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting...';

        // Submit vote
        submitVote(voteType, function(success, voteCounts) {
          if (success) {
            // Mark user as voted
            markUserAsVoted();
            
            // Transition to step 2 first
            if (step1) step1.classList.remove('active');
            if (step2) {
              step2.classList.add('active');
              showStep2ForVote(voteType);
              
              // Reset counters to 0 before animating
              if (dogCounter) dogCounter.textContent = '0';
              if (catCounter) catCounter.textContent = '0';
              
              // Small delay to ensure step 2 is visible, then animate
              setTimeout(function() {
                // Update vote counters with animation
                if (voteCounts && enableRealVote) {
                  updateVoteCountersFromData(voteCounts, true);
                } else {
                  updateVoteCountersStatic(true);
                }
              }, 100);
              
              step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          } else {
            // Re-enable button on error
            submitButton.disabled = false;
            submitButton.textContent = submitButton.dataset.originalText || 'Submit Vote';
            alert('Failed to submit vote. Please try again.');
          }
        });
      });
    }

    // Show step 2 content based on vote type
    function showStep2ForVote(voteType) {
      if (voteType === 'dog') {
        if (dogHeader) dogHeader.classList.remove('hidden');
        if (catHeader) catHeader.classList.add('hidden');
        if (dogItem) dogItem.classList.add('active');
        if (catItem) catItem.classList.remove('active');
        if (dogCta) dogCta.classList.remove('hidden');
        if (catCta) catCta.classList.add('hidden');
      } else if (voteType === 'cat') {
        if (dogHeader) dogHeader.classList.add('hidden');
        if (catHeader) catHeader.classList.remove('hidden');
        if (dogItem) dogItem.classList.remove('active');
        if (catItem) catItem.classList.add('active');
        if (dogCta) dogCta.classList.add('hidden');
        if (catCta) catCta.classList.remove('hidden');
      }
    }

    // Handle popup triggers
    if (dogPopupTrigger) {
      dogPopupTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (dogPopup) {
          dogPopup.classList.remove('hidden');
          document.body.style.overflow = 'hidden';
        }
      });
    }

    if (catPopupTrigger) {
      catPopupTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (catPopup) {
          catPopup.classList.remove('hidden');
          document.body.style.overflow = 'hidden';
        }
      });
    }

    // Handle popup close buttons
    if (dogPopupClose) {
      dogPopupClose.addEventListener('click', function() {
        if (dogPopup) {
          dogPopup.classList.add('hidden');
          document.body.style.overflow = '';
        }
      });
    }

    if (catPopupClose) {
      catPopupClose.addEventListener('click', function() {
        if (catPopup) {
          catPopup.classList.add('hidden');
          document.body.style.overflow = '';
        }
      });
    }

    // Close popup on overlay click
    [dogPopup, catPopup].forEach(function(popup) {
      if (popup) {
        const overlay = popup.querySelector('.iw-vote-popup-overlay');
        if (overlay) {
          overlay.addEventListener('click', function() {
            popup.classList.add('hidden');
            document.body.style.overflow = '';
          });
        }
      }
    });

    // Close popup on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        [dogPopup, catPopup].forEach(function(popup) {
          if (popup && !popup.classList.contains('hidden')) {
            popup.classList.add('hidden');
            document.body.style.overflow = '';
          }
        });
      }
    });

    // Handle promocode copy functionality
    const promocodeButtons = document.querySelectorAll('.iw-vote-popup-content-text-promocode button');
    promocodeButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const promocodeSpan = button.querySelector('span');
        if (promocodeSpan) {
          const promocode = promocodeSpan.textContent.trim();
          
          // Copy to clipboard
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(promocode).then(function() {
              // Visual feedback
              const originalText = promocodeSpan.textContent;
              promocodeSpan.textContent = 'Copied!';
              setTimeout(function() {
                promocodeSpan.textContent = originalText;
              }, 2000);
            }).catch(function() {
              fallbackCopy(promocode, promocodeSpan);
            });
          } else {
            fallbackCopy(promocode, promocodeSpan);
          }
        }
      });
    });

    // Fallback copy function for older browsers
    function fallbackCopy(text, feedbackElement) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      
      try {
        document.execCommand('copy');
        const originalText = feedbackElement.textContent;
        feedbackElement.textContent = 'Copied!';
        setTimeout(function() {
          feedbackElement.textContent = originalText;
        }, 2000);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
      
      document.body.removeChild(textArea);
    }

    // Submit vote function
    // ALWAYS store votes to Google Sheet if URL is provided
    // But only update percentages if enableRealVote is true
    function submitVote(voteType, callback) {
      console.log('submitVote called:', { voteType: voteType, googleSheetUrl: googleSheetUrl });
      
      if (googleSheetUrl && googleSheetUrl.includes('script.google.com')) {
        console.log('Submitting to Google Sheet...');
        // Always submit to Google Sheet for tracking
        submitToGoogleSheet(voteType, googleSheetUrl, function(success, counts) {
          console.log('Google Sheet submission result:', { success: success, counts: counts });
          if (success) {
            // If real vote is enabled, update with real percentages
            if (enableRealVote && counts) {
              updateVoteCountersFromData(counts);
            } else {
              // Otherwise, use static percentages from settings
              updateVoteCountersStatic();
            }
            if (callback) callback(true, counts);
          } else {
            console.error('Failed to submit vote to Google Sheet');
            // If Google Sheet fails, still show static percentages
            updateVoteCountersStatic();
            if (callback) callback(false);
          }
        });
      } else {
        console.warn('No Google Sheet URL provided or invalid URL:', googleSheetUrl);
        // No Google Sheet URL - just use static percentages
        setTimeout(function() {
          updateVoteCountersStatic();
          if (callback) callback(true);
        }, 500);
      }
    }

    // Submit vote to Google Sheet
    function submitToGoogleSheet(voteType, scriptUrl, callback) {
      // The scriptUrl should be the Google Apps Script Web App URL
      // Format: https://script.google.com/macros/s/{SCRIPT_ID}/exec
      
      console.log('Submitting vote to Google Sheet:', { voteType: voteType, scriptUrl: scriptUrl });
      
      if (!scriptUrl || !scriptUrl.includes('script.google.com')) {
        console.error('Invalid Google Apps Script URL:', scriptUrl);
        if (callback) callback(false);
        return;
      }

      // Google Apps Script works better with form submission due to CORS
      // Use form submission method directly (more reliable)
      submitToGoogleSheetFallback(voteType, scriptUrl, callback);
    }

    // Submit to Google Sheet using form submission (works better with Google Apps Script)
    function submitToGoogleSheetFallback(voteType, scriptUrl, callback) {
      console.log('Using form submission method for Google Sheet');
      
      // Create a unique iframe name for this submission
      const iframeName = 'hidden_iframe_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      
      // Create hidden iframe to handle response
      const iframe = document.createElement('iframe');
      iframe.name = iframeName;
      iframe.id = iframeName;
      iframe.style.display = 'none';
      iframe.style.width = '0';
      iframe.style.height = '0';
      document.body.appendChild(iframe);
      
      // Create form
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = scriptUrl;
      form.target = iframeName;
      form.style.display = 'none';
      
      // Add vote data as form fields
      const voteInput = document.createElement('input');
      voteInput.type = 'hidden';
      voteInput.name = 'vote';
      voteInput.value = voteType;
      form.appendChild(voteInput);
      
      const timestampInput = document.createElement('input');
      timestampInput.type = 'hidden';
      timestampInput.name = 'timestamp';
      timestampInput.value = new Date().toISOString();
      form.appendChild(timestampInput);
      
      // Append form to body
      document.body.appendChild(form);
      
      // Set a timeout in case iframe never loads
      let submissionTimeout = setTimeout(function() {
        console.warn('Form submission timeout - vote may still be processing');
        // Clean up
        if (form.parentNode) {
          document.body.removeChild(form);
        }
        if (iframe.parentNode) {
          document.body.removeChild(iframe);
        }
        // Still call callback - vote might have succeeded
        if (callback) callback(true);
      }, 5000); // 5 second timeout
      
      // Listen for iframe load to know when submission is complete
      iframe.onload = function() {
        clearTimeout(submissionTimeout);
        console.log('Form submission completed - checking Google Sheet execution logs to verify');
        console.log('To verify vote was recorded:');
        console.log('1. Go to Google Apps Script → Executions');
        console.log('2. Look for recent execution with your vote');
        console.log('3. Check your Google Sheet for the new row');
        
        // Clean up form and iframe
        setTimeout(function() {
          if (form.parentNode) {
            document.body.removeChild(form);
          }
          if (iframe.parentNode) {
            document.body.removeChild(iframe);
          }
        }, 1000);
        
        // Fetch updated vote counts after submission (if real vote is enabled)
        if (enableRealVote) {
          setTimeout(function() {
            fetchVoteCounts(scriptUrl, function(success, counts) {
              console.log('Fetched vote counts after submission:', { success: success, counts: counts });
              if (callback) callback(success, counts);
            });
          }, 1000); // Wait 1 second for vote to be recorded
        } else {
          // Real vote disabled - just confirm submission success
          if (callback) callback(true);
        }
      };
      
      // Also handle iframe errors
      iframe.onerror = function() {
        clearTimeout(submissionTimeout);
        console.error('Form submission error - check Apps Script deployment settings');
        console.error('Make sure deployment is set to "Anyone" access');
        // Clean up
        if (form.parentNode) {
          document.body.removeChild(form);
        }
        if (iframe.parentNode) {
          document.body.removeChild(iframe);
        }
        if (callback) callback(false);
      };
      
      // Submit form
      form.submit();
      console.log('Form submitted with vote:', voteType);
      console.log('Form data:', { vote: voteType, timestamp: new Date().toISOString() });
    }

    // Fetch vote counts from Google Sheet using JSONP (avoids CORS)
    function fetchVoteCounts(scriptUrl, callback) {
      const url = scriptUrl + '?action=getCounts';
      const callbackName = 'voteCountCallback_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      
      console.log('Fetching vote counts from Google Sheet...');
      
      // Create a script tag to fetch data (JSONP approach)
      const script = document.createElement('script');
      script.src = url + '&callback=' + callbackName;
      script.async = true;
      
      // Set up global callback function
      window[callbackName] = function(data) {
        // Clean up
        if (script.parentNode) {
          document.body.removeChild(script);
        }
        delete window[callbackName];
        
        if (data && data.success && data.counts) {
          console.log('Vote counts fetched successfully:', data.counts);
          if (callback) callback(true, data.counts);
        } else {
          console.error('Error fetching vote counts:', data?.error);
          if (callback) callback(false);
        }
      };
      
      // Handle script load error
      script.onerror = function() {
        console.error('Failed to load vote counts script');
        if (script.parentNode) {
          document.body.removeChild(script);
        }
        delete window[callbackName];
        if (callback) callback(false);
      };
      
      // Append script to body to trigger load
      document.body.appendChild(script);
    }

    // Animate counter from 0 to target value
    function animateCounter(element, targetValue, duration) {
      if (!element || !targetValue) return;
      
      const startValue = 0;
      const startTime = performance.now();
      const target = parseInt(targetValue) || 0;
      
      // Set initial value to 0
      element.textContent = startValue;
      
      function updateCounter(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing function for smooth animation (ease-out)
        const easeOut = 1 - Math.pow(1 - progress, 3);
        
        const currentValue = Math.round(startValue + (target - startValue) * easeOut);
        element.textContent = currentValue;
        
        if (progress < 1) {
          requestAnimationFrame(updateCounter);
        } else {
          // Ensure final value is exact
          element.textContent = target;
        }
      }
      
      requestAnimationFrame(updateCounter);
    }

    // Update vote counters from Google Sheets data (real percentages) with animation
    function updateVoteCountersFromData(counts, animate) {
      if (!counts) return;
      
      const shouldAnimate = animate !== false; // Default to true
      const animationDuration = 1500; // 1.5 seconds
      
      if (dogCounter && counts.dog) {
        if (shouldAnimate) {
          animateCounter(dogCounter, counts.dog.percentage, animationDuration);
        } else {
          dogCounter.textContent = counts.dog.percentage;
        }
      }
      if (catCounter && counts.cat) {
        if (shouldAnimate) {
          animateCounter(catCounter, counts.cat.percentage, animationDuration);
        } else {
          catCounter.textContent = counts.cat.percentage;
        }
      }
    }

    // Update vote counters with static percentages from settings with animation
    function updateVoteCountersStatic(animate) {
      const shouldAnimate = animate !== false; // Default to true
      const animationDuration = 1500; // 1.5 seconds
      
      // Read from data-vote-counter attribute (from Liquid settings)
      // This is the value set in the HTML from block.settings.dog_vote_score
      if (dogCounter) {
        const dogAttrValue = dogCounter.getAttribute('data-vote-counter');
        let targetValue = null;
        
        // Use attribute value if it exists, otherwise fallback to staticDogScore
        if (dogAttrValue !== null && dogAttrValue !== '') {
          targetValue = parseInt(dogAttrValue);
        } else if (staticDogScore > 0) {
          targetValue = staticDogScore;
        }
        
        if (targetValue !== null && targetValue > 0) {
          if (shouldAnimate) {
            animateCounter(dogCounter, targetValue, animationDuration);
          } else {
            dogCounter.textContent = targetValue;
          }
        }
      }
      
      if (catCounter) {
        const catAttrValue = catCounter.getAttribute('data-vote-counter');
        let targetValue = null;
        
        // Use attribute value if it exists, otherwise fallback to staticCatScore
        if (catAttrValue !== null && catAttrValue !== '') {
          targetValue = parseInt(catAttrValue);
        } else if (staticCatScore > 0) {
          targetValue = staticCatScore;
        }
        
        if (targetValue !== null && targetValue > 0) {
          if (shouldAnimate) {
            animateCounter(catCounter, targetValue, animationDuration);
          } else {
            catCounter.textContent = targetValue;
          }
        }
      }
    }

    // Load initial vote counts on page load (no animation on initial load)
    // If enable_real_vote is false, always use static values from data-vote-counter
    if (!enableRealVote) {
      // Real vote disabled - use static percentages from settings (no animation on load)
      updateVoteCountersStatic(false);
    } else if (googleSheetUrl && googleSheetUrl.includes('script.google.com')) {
      // Real vote enabled - fetch real counts from Google Sheet using JSONP
      console.log('Real vote enabled - fetching counts from Google Sheet...');
      fetchVoteCounts(googleSheetUrl, function(success, counts) {
        if (success && counts) {
          console.log('Real vote counts loaded:', counts);
          updateVoteCountersFromData(counts, false); // No animation on initial load
        } else {
          console.warn('Failed to fetch real counts, using static values');
          updateVoteCountersStatic(false);
        }
      });
    } else {
      // No Google Sheet URL, use static percentages (no animation on load)
      updateVoteCountersStatic(false);
    }

    // Store original button text
    if (submitButton) {
      submitButton.dataset.originalText = submitButton.textContent;
    }
  });
})();

